






























import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import Loading from '@/components/Loading.vue'
import ScorecardSubpage from '@/pages/scorecard/components/ScorecardSubpage.vue'
import {Action, Getter} from 'vuex-class'
import {ILeaderboardResult, INPSSummary} from '@/entities'
import {ScorecardEntity} from '@/entities/scorecard'
import {getOrdinal} from '@/utils/number'
import ScorecardRankRow from '@/components/Scorecard/ScorecardRankRow.vue'
import {embedded} from '@/utils/react-native-webview'

@Component<ScorecardRank>({
    components: {ScorecardRankRow, ScorecardSubpage, Loading},
    filters: {
        getOrdinal
    }
})
export default class ScorecardRank extends Vue {

    @Getter public slide !: string
    @Getter public scorecard!: ScorecardEntity
    @Getter public companyNpsSummary !: INPSSummary
    @Getter public scorecardOutdated!: boolean
    @Getter public scorecardLoading!: boolean

    @Action public loadScorecard
    @Action public loadCompanyNpsSummary

    @Prop({type: String, default: null})
    public teamMemberUserId !: string // view another users rank

    public get loading() {
        return this.scorecardLoading
    }

    public get isRankDisabled() {
        return this.scorecard && !this.scorecard.rankEnabled
    }

    public mounted() {
        this.load()
    }

    public async load() {
        await this.loadCompanyNpsSummary(this.teamMemberUserId ?? null)

        if (this.scorecardOutdated) {
            await this.loadScorecard(this.teamMemberUserId ?? null)
        }
    }

    public get title() {
        if (!this.scorecard) {
            return 'loading...'
        }

        const {rankValues, rankFieldLabel} = this.scorecard
        const title = this.scorecard.rankValues.filter(rank => rank > 0 ).join(', ')
        return `<div style="margin-bottom: -5px;">
                    Rank ${title} <br>
                    <span style="font-size: 12px;">in ${rankFieldLabel}</span>
                </div>`
    }

    public get rankListTitle() {
        return this.scorecard.rankLimitNumber ?
            `Top ${this.scorecard.rankLimitNumber} Performers` : 'Team Rankings'
    }

    public get visibleRankRows() {
        if (this.scorecard.rankLimitNumber) {
            return this.scorecard.ranks.slice(0, this.scorecard.rankLimitNumber)
        }
        return this.scorecard.ranks
    }

    public getAvatar(row: ILeaderboardResult) {
        if (this.scorecard.avatars[row.name] === undefined) {
            return ``
        }

        return this.scorecard.avatars[row.name]
    }

    public get minValue() {
        return Math.min(...this.scorecard.ranks.filter((rank) => rank.responded >= 5).map((rank) => rank.nps))
    }

    public get maxValue() {
        return Math.max(...this.scorecard.ranks.filter((rank) => rank.responded >= 5).map((rank) => rank.nps))
    }

    public get companyNps() {
        return Number(this.companyNpsSummary.nps.toFixed(1))
    }

    public get embedded() {
        return embedded
    }
}
